'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/* eslint-disable prettier/prettier */
const animals = [
    "albatros",
    "aligator",
    "alpaka",
    "mrówka",
    "mrówkojad",
    "antylopa",
    "pancernik",
    "borsuk",
    "barrakuda",
    "nietoperz",
    "niedźwiedź",
    "pszczoła",
    "bizon",
    "bawół",
    "motyl",
    "wielbłąd",
    "kapibara",
    "karibu",
    "kot",
    "gąsienica",
    "gepard",
    "szynszyl",
    "kobra",
    "kormoran",
    "kojot",
    "krab",
    "żuraw",
    "krokodyl",
    "jeleń",
    "dinozaur",
    "delfin",
    "gołąb",
    "ważka",
    "kaczka",
    "orzeł",
    "dziobak",
    "słoń",
    "łoś",
    "emu",
    "sokół",
    "fretka",
    "ryba",
    "flaming",
    "lis",
    "gazela",
    "żyrafa",
    "dzięcioł",
    "goryl",
    "konik",
    "sójka",
    "chomik",
    "zając",
    "jastrząb",
    "jeż",
    "śledź",
    "hipopotam",
    "szerszeń",
    "koń",
    "koliber",
    "koza",
    "jaguar",
    "sójka",
    "meduza",
    "kangur",
    "królik",
    "koza",
    "krab",
    "kuna",
    "kameleon",
    "kos",
    "łabędź",
    "tygrys",
    "wieloryb",
    "wilk",
    "rosomak",
    "wombat",
    "bekas",
    "zebra",
];
const adjectives = [
    "absolutny",
    "uroczy",
    "śmiały",
    "uznany",
    "doświadczony",
    "dokładny",
    "akrobatyczny",
    "aktywny",
    "rzeczywisty",
    "biegły",
    "podziwiany",
    "nastoletni",
    "uroczy",
    "ukochany",
    "zaawansowany",
    "czuły",
    "zwinny",
    "czujny",
    "żywy",
    "altruistyczny",
    "niesamowity",
    "ambitny",
    "rozbawiony",
    "rozrywkowy",
    "starożytny",
    "animowany",
    "antyczny",
    "nieśmiały",
    "zdolny",
    "arktyczny",
    "artystyczny",
    "zdumiewający",
    "sprawny",
    "uważny",
    "atrakcyjny",
    "autentyczny",
    "upoważniony",
    "automatyczny",
    "fantastyczny",
    "piękny",
    "ukochany",
    "korzystny",
    "duży",
    "błogi",
    "niebieski",
    "śmiały",
    "skoczny",
    "odważny",
    "jasny",
    "błyszczący",
    "genialny",
    "złoty",
    "wdzięczny",
    "łaskawy",
    "wielki",
    "zielony",
    "przystojny",
    "przydatny",
    "szczęśliwy",
    "harmonijny",
    "zdrowy",
    "serdeczny",
    "szlachetny",
    "porywający",
    "imponujący",
    "niezrównany",
    "niewiarygodny",
    "niechciany",
    "niewinny",
    "radosny",
    "uradowany",
    "lśniący",
    "wspaniały",
    "majestatyczny",
    "ważny",
    "miętowy",
    "nowoczesny",
    "tajemniczy",
    "optymistyczny",
    "pomarańczowy",
    "uporządkowany",
    "ozdobny",
    "oryginalny",
    "wybitny",
    "namiętny",
    "spokojny",
    "zadowolony",
    "pozytywny",
    "potężny",
    "produktywny",
    "dumny",
    "fioletowy",
    "zdezorientowany",
    "rzeczywisty",
    "rozsądny",
    "niezwykły",
    "niepowtarzalny",
    "atłasowy",
    "czebura",
    "sprawiedliwy",
    "prawdziwy",
    "prawdziwy",
    "najlepszy",
    "niezwykły",
    "unikalny",
    "atłasowy",
    "czczony",
    "sprawdzalny",
    "promienny",
    "zwycięski",
    "czujny",
    "energiczny",
    "fioletowy",
    "cnotliwy",
    "istotny",
    "ciepły",
    "serdeczny",
    "czujny",
    "cały",
    "mądry",
    "taktowny",
    "wspaniały",
    "żarliwy",
];
const sample = (arr) => {
    return arr[Math.floor(Math.random() * arr.length)];
};
const upperFirst = (str) => str[0].toUpperCase() + str.slice(1);
const getRandomUsername = () => {
    const randomAnimal = sample(animals);
    const randomAdjective = sample(adjectives);
    // Sprawdź, czy ostatnia litera zwierzęcia to "a"
    const lastLetterIsA = randomAnimal.charAt(randomAnimal.length - 1).toLowerCase() === "a";
    // Jeśli ostatnia litera zwierzęcia to "a", zamień ostatnią literę przymiotnika na "a" za pomocą template literals
    const modifiedAdjective = lastLetterIsA
        ? `${randomAdjective.slice(0, -1)}a`
        : randomAdjective;
    return `${upperFirst(modifiedAdjective)} ${upperFirst(randomAnimal)}`;
};

exports.adjectives = adjectives;
exports.animals = animals;
exports.getRandomUsername = getRandomUsername;
